<mf-page title="Detalles de la operación">
  @if (operationDto) {
  <mf-column-display label="Id">{{ operationDto.id }}</mf-column-display>
  }
</mf-page>
